import React from 'react';
import { STRINGS } from 'config';
import { Select, useSelect } from '@econsult/econsult-ui/dist/components/Select';
import _map from 'lodash/map';
import { ChevronIcon } from '@econsult/econsult-ui/dist/assets';
import { Option, SelectOptions, SelectButton, Tick } from 'components/Form/Select';

const { CLOSURE_TYPE } = STRINGS;

export const ClosureTypeSelect = ({ closureType, onSelectClosureType }) => {
  const { toggleSelect, selectContext } = useSelect();
  const handleSelectClosureType = closureId => event => {
    onSelectClosureType(closureId);
    event.preventDefault();
  };
  return (
    <Select
      closeOnClickOutside
      selectContext={selectContext}
      automationName="ClosureTypeDropdown"
      theme="light"
    >
      <SelectButton onClick={toggleSelect} type="button" data-automation="ClosureTypeDropdownButton">
        <span>{CLOSURE_TYPE[closureType]?.label || 'Select a closure type'}</span>
        <ChevronIcon />
      </SelectButton>
      <SelectOptions>
        {_map(CLOSURE_TYPE, _closureType => (
          <Option
            key={_closureType.id}
            onClick={handleSelectClosureType(_closureType.id)}
            data-automation={`ClosureTypeOption-${_closureType.id}`}
          >
            <span>{_closureType.label}</span>
            <Tick automationName="SelectedClosureTypeIndicator" isVisible={closureType === _closureType.id} />
          </Option>
        ))}
      </SelectOptions>
    </Select>
  );
};
